export const apiPath = '/v1/comments';
const actionType = 'COMMENT';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
